import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ productAttributeParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `globalAttribute/getSearched`,
      params: productAttributeParams,
    });
    const allProductAttribute = data;
    yield put(Actions.setAll({ allProductAttribute }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateProductAttribute({ productAttributeData, actionName, productAttributeParams, onSuccess }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `globalAttribute`,
      data: productAttributeData,
    });
    yield put(Actions.fetchAll({ productAttributeParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.PRODUCT_ATTRIBUTE_CREATED
        : CONSTANT_VARIABLES.PRODUCT_ATTRIBUTE_UPDATED,
      ''
    );
    if (typeof onSuccess === 'function') {
      yield call(onSuccess);
    }
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteProductAttribute({ id, productAttributeParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `GlobalAttribute/${id}`,
    });
    yield put(Actions.fetchAll({ productAttributeParams }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllProductAttributesOptions() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'productAttribute',
    });
    const allProductAttributeOptions = data;
    yield put(Actions.setAllProductAttributesOptions({ allProductAttributeOptions }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err);
  }
}

function* fetchAllGlobalAttributes() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'globalAttribute',
    });
    const allGlobalAttributes = data;
    yield put(Actions.setAllGlobalAttributes({ allGlobalAttributes }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err);
  }
}

function* fetchAllDataTypes() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `globalAttribute/getAllDataTypes`,
    });
    const allDataTypes = data;
    yield put(Actions.setAllDataTypes({ allDataTypes }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchProductAttributeById({ id }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `globalAttribute/${id}`,
    });
    const productAttributeById = data;
    yield put(Actions.setProductAttributeById({ productAttributeById }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* getAllDataInCSV() {
  try {
    yield put(Actions.setGlobalAttributeExportDataLoader({ showGlobalAttributeExportDataLoader: true }));
    const { data } = yield call(api.get, {
      route: 'globalAttribute/GetAllCSVData',
    });
    const globalAttributeExportCSVData = data;
    yield put(Actions.setGlobalAttributesDataExport({ globalAttributeExportCSVData }));
    notification('success', CONSTANT_VARIABLES.FILE_DOWNLOADED_SUCCESSFULLY, '');
    yield put(Actions.setGlobalAttributeExportDataLoader({ showGlobalAttributeExportDataLoader: false }));
  } catch (error) {
    yield put(Actions.setGlobalAttributeExportDataLoader({ showGlobalAttributeExportDataLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* importExcelToolFile({ importFileParams, productAttributeParams }) {
  try {
    // yield put(Actions.setLoader({ showLoader: true }));
    yield put(Actions.setImportExcelToolFileLoader({ importExcelFileLoader: true }));
    const { data } = yield call(api.post, {
      route: 'globalAttribute/postGlobalAttributefile',
      data: importFileParams.file,
    });
    const importProductAttributeFile = data;
    yield put(Actions.setImportExcelToolFile({ importProductAttributeFile }));
    yield put(Actions.setImportExcelToolFileLoader({ importExcelFileLoader: false }));
    yield put(Actions.fetchAll({ productAttributeParams }));
    // notification('success', CONSTANT_VARIABLES.FILE_UPLOADED_SUCCESSFULLY, '');
  } catch (error) {
    notification('error', error, '');
    yield put(Actions.setImportExcelToolFileLoader({ importExcelFileLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* getAllGlobalAttributes() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'globalAttribute/AttributesWithTypes',
    });
    const allGlobalAttributes = data;
    yield put(Actions.setAllGlobalAttributes({ allGlobalAttributes }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err);
  }
}

function* addDateFormat({ formatString, dataTypeId, onSuccess }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.post, {
      route: 'globalAttribute/addDateFormat',
      data: { formatString, dataTypeId },
    });
    yield put(Actions.fetchAllDataTypes());
    notification('success', 'Date format added successfully.', '');
    if (typeof onSuccess === 'function') {
      yield call(onSuccess);
    }
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err);
  }
}

function* deleteDateFormat({ id, onSuccess }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `globalAttribute/deleteDateFormat/${id}`,
    });
    yield put(Actions.fetchAllDataTypes());
    notification('success', 'Date format deleted successfully.', '');
    if (typeof onSuccess === 'function') {
      yield call(onSuccess);
    }
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    const message = err?.exceptionContent || err.toString();
    notification('error', message, '');
    console.warn(err);
  }
}
export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.FETCH_ALL_PRODUCT_ATTRIBUTES_OPTIONS, fetchAllProductAttributesOptions),
    takeLatest(ActionTypes.ADD_OR_UPDATE_PRODUCT_ATTRIBUTE, addorUpdateProductAttribute),
    takeLatest(ActionTypes.FETCH_ALL_DATA_TYPES, fetchAllDataTypes),
    takeLatest(ActionTypes.DELETE_PRODUCT_ATTRIBUTE, deleteProductAttribute),
    takeLatest(ActionTypes.FETCH_PRODUCT_ATTRIBUTE_BY_ID, fetchProductAttributeById),
    takeLatest(ActionTypes.FETCH_ALL_GLOBAL_ATTRIBUTES, fetchAllGlobalAttributes),
    takeLatest(ActionTypes.GET_ALL_CSV_DATA, getAllDataInCSV),
    takeLatest(ActionTypes.PRODUCT_ATTRIBUTE_IMPORT, importExcelToolFile),
    takeLatest(ActionTypes.GET_ALL_GLOBAL_ATTRIBUTES, getAllGlobalAttributes),
    takeLatest(ActionTypes.ADD_DATE_FORMAT, addDateFormat),
    takeLatest(ActionTypes.DELETE_DATE_FORMAT, deleteDateFormat),
  ]);
}
